export const BASE_URL = '/api/v1';
export const BASE_URL_V2 = '/api/v2';
export const BASE_URL_V2_1 = '/api/v2.1';
export const BASE_URL_V3 = '/api/v3';
export const WHITEBOARD_KEY = '434ee63c-c5e6-4f56-8332-720685fede25';
export const LEARNOSITY_ITEMS_API = 'https://items-ie.learnosity.com/?v2023.3.LTS';
export const LEARNOSITY_ITEMS_API_FALLBACK = 'https://items.learnosity.com/?v2023.3.LTS';
export const LEARNOSITY_QUESTIONS_API =
  'https://questions-ie.learnosity.com/?v2023.3.LTS';
export const LEARNOSITY_QUESTIONS_API_FALLBACK =
  'https://questions.learnosity.com/?v2023.3.LTS';
export const SENTRY_DSN = 'https://3629598e1ca648dbb845007d23cf47d3@sentry.io/1331407';
export const CUEMATH_APP_URL = 'https://cuemath.onelink.me/Zb5o/website';
export const MATHJAX_URL = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml-full.js';

export const isStaging =
  import.meta.env.MODE === 'staging' || import.meta.env.MODE?.includes('testenv');
export const isDev = import.meta.env.DEV;
export const isProduction = !(isDev || isStaging);

let openTokKey = null;

if (isDev || isStaging) {
  openTokKey = '46282432';
} else {
  openTokKey = '46187592';
}
export const OPEN_TALK_KEY = openTokKey;

let EVENTS_API_URL = null;

if (isDev) {
  EVENTS_API_URL =
    'https://lh5mj1951d.execute-api.ap-southeast-1.amazonaws.com/default/intel-dev-student-alerts-api';
} else if (isStaging) {
  EVENTS_API_URL =
    'https://jdcal120td.execute-api.ap-southeast-1.amazonaws.com/default/intel-test-student-alerts-api';
} else {
  EVENTS_API_URL =
    'https://n88vuwn1vi.execute-api.ap-southeast-1.amazonaws.com/default/intel-student-alerts-api';
}
export const STUDENT_EVENTS_API = EVENTS_API_URL;
export const MIXPANEL_TOKEN = isDev ? 'be4fd18969ada70ab3379a294c154463' : '';
